export { EloBankWireEnIcon } from './bank-wire-en-icon'
